import { render, staticRenderFns } from "./admixCalc.vue.pug?vue&type=template&id=82808b1c&lang=pug&"
import script from "./admixCalc.vue.js?vue&type=script&lang=js&"
export * from "./admixCalc.vue.js?vue&type=script&lang=js&"
import style0 from "./admixCalc.vue.css?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports